import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=ba70f88c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba70f88c')) {
      api.createRecord('ba70f88c', component.options)
    } else {
      api.reload('ba70f88c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=ba70f88c&", function () {
      api.rerender('ba70f88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23ho07D2vrbu6/JS/comp/ImgFallback.vue"
export default component.exports